import ShadowContainerHorizontal from '@atoms/ShadowContainerHorizontal/ShadowContainerHorizontal';
import { IMeta } from '@models/IMeta';
import classNames from 'classnames';

interface Props {
  readonly highlights: string[];
  readonly title?: string;
  readonly meta: IMeta;
  readonly anchorId: string;
}

const OverviewTechSpecs = ({
  highlights,
  title,
  meta,
  anchorId = '',
}: Props) => {
  const displayedHighlights = highlights
    .slice(0, 5)
    .filter((highlight) => highlight);

  return (
    <section
      id={`a-${anchorId}`}
      className="component-padding bg-white dark:bg-black-100"
    >
      {title && (
        <div className="container mb-7.5 xl:grid xl:grid-cols-12">
          <h2
            data-epi-property-name={meta?.editHints?.title}
            className="h5 text-black-100 xl:col-span-10 xl:col-start-2 dark:text-white"
          >
            {title}
          </h2>
        </div>
      )}

      <div
        className={classNames(
          `${
            displayedHighlights.length === 1 ? 'container' : 'md:container'
          } xl:grid xl:grid-cols-12`
        )}
      >
        <div className="xl:col-span-10 xl:col-start-2">
          <ShadowContainerHorizontal threshold={0.01}>
            <div
              className="flex gap-x-5 lg:grid lg:w-full lg:auto-cols-fr lg:grid-flow-col lg:gap-x-4 lg:whitespace-normal"
              data-epi-edit={meta?.editHints?.highlights}
            >
              {displayedHighlights.map((highlight) => (
                <span
                  key={highlight}
                  className="body-two flex grow select-none items-center justify-center rounded-[5px] bg-grey-100 px-4 py-5 text-center text-black-100 dark:bg-grey-600 dark:text-white"
                >
                  {highlight}
                </span>
              ))}
            </div>
          </ShadowContainerHorizontal>
        </div>
      </div>
    </section>
  );
};

export default OverviewTechSpecs;
